import script from "./AdditionWarnSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdditionWarnSetting.vue?vue&type=script&lang=ts&setup=true"

import "./AdditionWarnSetting.vue?vue&type=style&index=0&id=85e90f34&lang=scss&scope=true"

const __exports__ = script;

export default __exports__